import classes from '@src/styles/Wordpress.module.css'
import Head from 'next/head'
import parse from 'html-react-parser'
import { wordpressGroups } from '@src/constants/wordpress'
import classNames from 'classnames'

const defaultDescription =
  'At Dimension, we provide simple and sustainable waste management solutions for homes and businesses across the country. From junk removal and dumpster rentals to recycling and hazardous waste disposal, we offer a range of customizable services to fit your unique needs and budget.'

function extractTextFromHtml(htmlString: string) {
  let extractedText = ''

  function replace(node: any) {
    if (node.type === 'text') {
      extractedText += node.data
    }
  }

  // Parse the HTML string and call the replace function for each node.
  parse(htmlString, { replace })

  return extractedText
}

function WordpressPost({ data, related, group, setRef }: any) {
  let titleName = data?.title?.rendered?.split('#038;')?.join('') ?? 'Post'
  titleName = titleName?.split('&#8211;')?.join('-')
  titleName = titleName?.split('&#8217;')?.join("'")
  const titleGroup = wordpressGroups.blog.name
  const title = `${titleName} - ${titleGroup} | Dimension`
  let description = data?.excerpt?.rendered?.split('#038;')?.join('') || defaultDescription
  description = extractTextFromHtml(description)
  description = description?.slice(0, 160) ?? defaultDescription
  let fixedHtml = data?.content?.rendered?.split('#038;')?.join('')
  fixedHtml = fixedHtml?.split('trashwarrior.com/booking')?.join('app.getdimension.com/booking')
  fixedHtml = fixedHtml
    ?.split('https://getdimension.com/booking')
    ?.join('https://app.getdimension.com/booking')

  const relatedLinks = (Array.isArray(related) ? related : [])
    .filter((rel: any) => !!rel.title)
    .map((rel: any) => ({
      title: rel?.title?.rendered?.split('#038;')?.join(''),
      url: `${process.env.NEXT_PUBLIC_HOSTING_URL_PRIMARY}${group}/${rel?.slug ?? ''}`,
    }))

  const backButton = group
    ? `${process.env.NEXT_PUBLIC_HOSTING_URL_PRIMARY}${group}`
    : process.env.NEXT_PUBLIC_HOSTING_URL_PRIMARY

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <section>
        <div className={classNames(classes.wrapper, 'root')}>
          <div id='wordpress-post' />
          <div ref={setRef} className={classes.root}>
            <a href={backButton}>Back to {group ?? 'home'}</a>
            <h1>{titleName}</h1>
            {parse(fixedHtml ?? '') || 'No content'}
          </div>
        </div>
      </section>
      {group && (
        <section className={classes.relatedSection}>
          <h4>Related Articles</h4>
          <nav className={classes.relatedList}>
            {relatedLinks?.map((link: any) => (
              <a key={link.url} href={link.url} className={classes.relatedArticle}>
                {link.title}
              </a>
            ))}
          </nav>
        </section>
      )}
    </>
  )
}

export default WordpressPost
